import {SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class PreparationModifierValuesSearchModel extends SearchModel<any> {

    constructor(injector: Injector) {
        super(injector);
    }

    override getIdentifierField(): string {
        return "metaTagValueId";
    }

    override getResourceName(): string {
        return "meta-tag-definition-values";
    }

    override getResource(): string {
        return "preparation-modifier-values";
    }

    findByValueId(id: number): Promise<any> {
        return this.searchRecords({metaTagValueId: id}, undefined, undefined, undefined).toPromise()
            .then(searchData => Promise.resolve(searchData.totalCount === 1 ? searchData.data[0] : undefined));
    }
}
